var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59063 0.806936C7.83137 0.619693 8.16847 0.619693 8.40921 0.806936L14.4092 5.4736C14.5716 5.59991 14.6666 5.79411 14.6666 5.99984V13.3332C14.6666 13.8636 14.4559 14.3723 14.0808 14.7474C13.7057 15.1225 13.197 15.3332 12.6666 15.3332H3.33325C2.80282 15.3332 2.29411 15.1225 1.91904 14.7474C1.54397 14.3723 1.33325 13.8636 1.33325 13.3332V5.99984C1.33325 5.79411 1.42823 5.59991 1.59062 5.4736L7.59063 0.806936ZM2.66659 6.32589V13.3332C2.66659 13.51 2.73682 13.6795 2.86185 13.8046C2.98687 13.9296 3.15644 13.9998 3.33325 13.9998H12.6666C12.8434 13.9998 13.013 13.9296 13.138 13.8046C13.263 13.6795 13.3333 13.51 13.3333 13.3332V6.32589L7.99992 2.17774L2.66659 6.32589Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33325 8.00016C5.33325 7.63197 5.63173 7.3335 5.99992 7.3335H9.99992C10.3681 7.3335 10.6666 7.63197 10.6666 8.00016V14.6668C10.6666 15.035 10.3681 15.3335 9.99992 15.3335C9.63173 15.3335 9.33325 15.035 9.33325 14.6668V8.66683H6.66659V14.6668C6.66659 15.035 6.36811 15.3335 5.99992 15.3335C5.63173 15.3335 5.33325 15.035 5.33325 14.6668V8.00016Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e5aa9a94e9fef5dd26e6fee2578847f8.svg";
export { ForwardRef as ReactComponent };